import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark' | 'system';

function getEffective(t: Theme): 'light' | 'dark' {
  if (t === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return t;
}

function applyTheme(t: Theme) {
  const effective = getEffective(t);
  const root = document.documentElement;
  if (effective === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');

  // Atualiza meta theme-color para combinar com o tema (mobile browser bar)
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', effective === 'dark' ? '#080c14' : '#fafbfc');
  }
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    try {
      const saved = localStorage.getItem('emf_theme') as Theme | null;
      return saved || 'dark';
    } catch {
      return 'dark';
    }
  });

  useEffect(() => {
    applyTheme(theme);
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const listener = () => {
      if (theme === 'system') applyTheme('system');
    };
    mq.addEventListener('change', listener);
    return () => mq.removeEventListener('change', listener);
  }, [theme]);

  const setTheme = (t: Theme) => {
    try {
      localStorage.setItem('emf_theme', t);
    } catch {
      /* ignore */
    }
    setThemeState(t);
  };

  return { theme, setTheme, effective: getEffective(theme) };
}
